export const test = [
  {
    name: 'age',
  },
  {
    name: 'goal',
  },
];
